import { createSlice } from "@reduxjs/toolkit";

const languageSlice = createSlice({
  name: "language",
  initialState: {
    activelanguages: [
      {
        initialText: "",
        checkbox: {
          improveLang: false,
          concise: false,
          translate: false,
        },
        responseId: 1,
        language: "",
      },
      {
        initialText: "",
        checkbox: {
          improveLang: false,
          concise: false,
          translate: false,
        },
        responseId: 1,
        language:
          "Artificial Intelligence (AI) offers a wide range of benefits across various industries and applications...",
      },
      {
        responseId: 2,
        language:
          "The Company received $XXm in insurance proceeds in MmmYYA,..",
      },
      {
        responseId: 3,
        language:
          "XYZ is well-positioned to benefit from the compressed timeframe in which OEMs must introduce vehicles",
      },
    ],
  },
  reducers: {},
});

export const { setAiGeneratedText } = languageSlice.actions;

export default languageSlice.reducer;
